import { TimePicker } from "antd";
import Commonformlabel from "./CommonFormLabel";
import Commonformerror from "./CommonFormError";
import dayjs, { Dayjs } from "dayjs";

type DisabledTime = (now: Dayjs) => {
  disabledHours?: () => number[];
  disabledMinutes?: (selectedHour: number) => number[];
  disabledSeconds?: (selectedHour: number, selectedMinute: number) => number[];
  disabledMilliseconds?: (
    selectedHour: number,
    selectedMinute: number,
    selectedSecond: number
  ) => number[];
};

function Commontimepicker({
  onChange,
  size,
  labelname,
  value,
  required = false,
  touched,
  error,
  name,
  FromTime,
  ToTime,
  DateType,
  onSelect,
  changeOnScroll = false,
}: {
  onChange: (data: any) => void;
  size: any;
  labelname: string;
  value?: any;
  required?: boolean;
  touched?: any;
  error?: any;
  name: string;
  FromTime: null;
  ToTime: null;
  DateType: string;
  onSelect?: (value: any) => void;
  changeOnScroll?: boolean;
}) {
  const DisableFutureTime = (now: Dayjs) => {
    if (name === "to_time") {
      const hours: any = [];
      const minutes: any = [];
      const selectedhour = FromTime && parseInt(dayjs(FromTime).format("HH"));
      const selectedminutes =
        FromTime && parseInt(dayjs(FromTime).format("mm"));
      const HourofTotime = value && parseInt(dayjs(value).format("HH"));
      const MinuteofTotime = dayjs(value).format("mm");

      if (selectedhour) {
        for (let i: any = selectedhour; i <= 24; i--) {
          if (i == 0) {
            break;
          }
          hours.push(i);
        }
      }

      if (selectedhour === 0 && selectedminutes === 0) {
        if (selectedhour === 0) {
          return {
            disabledMinutes: () => minutes,
            disabledHours: () => [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19, 20, 21, 22, 23,
            ],
          };
        }
        if (selectedminutes === 0) {
          return {
            disabledMinutes: () => [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34,
              35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
              51, 52, 53, 54, 55, 56, 57, 58, 59,
            ],
            disabledHours: () => hours,
          };
        }
      }

      if (selectedhour === HourofTotime) {
        let m = hours.filter((ele: any, ind: number) => {
          return ele === selectedhour ? hours.splice(ind, 1) : ele;
        });

        let i: any = selectedminutes;

        while (i <= 60) {
          if (i === 0) {
            break;
          }
          minutes.push(i);

          i = i - 1;
        }
      } else if (FromTime) {
        let m = hours.filter((ele: any, ind: number) => {
          return ele === selectedhour ? hours.splice(ind, 1) : ele;
        });

        return {
          disabledMinutes: () => [],
          disabledHours: () => hours,
        };
      }

      return {
        disabledHours: () => hours,
        disabledMinutes: () => minutes,
      };
    } else if (name === "from_time") {
      const hours: any = [];
      const minutes: any = [];
      const selectedhour = ToTime && parseInt(dayjs(ToTime).format("HH"));
      const selectedminutes = ToTime && parseInt(dayjs(ToTime).format("mm"));
      const HourofFromtime = value && parseInt(dayjs(value).format("HH"));
      const MinuteofFromtime = value && parseInt(dayjs(value).format("mm"));

      if (selectedhour) {
        for (let i: any = selectedhour; i <= 24; i++) {
          hours.push(i);
        }
      }

      if (selectedhour === 0 && selectedminutes === 0) {
        if (selectedhour === 0) {
          return {
            disabledMinutes: () => minutes,
            disabledHours: () => [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19, 20, 21, 22, 23, 24,
            ],
          };
        } else if (selectedminutes === 0) {
          return {
            disabledMinutes: () => [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34,
              35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
              51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
            ],
            disabledHours: () => [hours],
          };
        }
      }
      if (selectedminutes === 0 || selectedhour === 0) {
        if (selectedminutes == 0) {
          return {
            disabledMinutes: () => [],
            disabledHours: () => hours,
          };
        } else if (selectedhour === 0) {
          return {
            disabledMinutes: () => [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34,
              35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
              51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
            ],
            disabledHours: () => [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19, 20, 21, 22, 23, 24,
            ],
          };
        }
      }

      if (selectedhour === HourofFromtime) {
        let m = hours.filter((ele: any, ind: number) => {
          return ele === selectedhour ? hours.splice(ind, 1) : ele;
        });
        let i: any = selectedminutes;

        while (i <= 60) {
          if (i === 0) {
            break;
          }
          minutes.push(i);
          i = i + 1;
        }
      } else if (ToTime && selectedminutes !== 0 && selectedminutes !== 0) {
        let m = hours.filter((ele: any, ind: number) => {
          return ele === selectedhour ? hours.splice(ind, 1) : ele;
        });

        return {
          disabledMinutes: () => [],
          disabledHours: () => hours,
        };
      }

      return {
        disabledHours: () => hours,
        disabledMinutes: () => minutes,
      };
    }
    return {
      disabledHours: () => [],
      disabledMinutes: () => [],
    };
  };

  return (
    <>
      <Commonformlabel labelname={labelname} required={required} />

      <TimePicker
        onChange={onChange}
        className="w-100"
        size={size}
        value={value}
        format="HH:mm"
        inputReadOnly={true}
        // disabledTime={(date: Dayjs) => DisableFutureTime(date)}
        // onSelect={onSelect}
        allowClear
        needConfirm={false}
        changeOnScroll
      />

      <Commonformerror
        required={required}
        touched={touched}
        name={name}
        error={error}
      />
    </>
  );
}

export default Commontimepicker;
